import { RootStateModel } from '../models/root-state.model';

export const loadingFulfilledMatcher = (state: RootStateModel) => {
  state.isLoading = false;
};
